import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _isEmpty from "lodash/isEmpty";
import _isNil from "lodash/isNil";
import { search } from "../SearchText";
import DriverQuotesTable from "./DriverQuotesTable";
import DriverQuotesSearch from "./DriverQuotesSearch";
import DriverQuotesFilter from "./DriverQuotesFilter";
import styles from "../../styles/components/DriverQuotes.css";
import { B2B_VALUE_DICT } from "../../modules/drivers";

const INCOME_AUDIENCE_ID = 1;
const GENDER_AUDIENCE_ID = 2;
const AGE_AUDIENCE_ID = 3;
const EDUCATION_AUDIENCE_ID = 4;
const B2C_CATEGORY_ID = 1;
const B2B_CATEGORY_ID = 2;

function filterBySegment(driverQuotes, interestingAudiences, selectedSegments) {
    return driverQuotes.filter(({ segmentIds }) => {
        // segmentIds must include all of the selectedSegments in order for the quote to appear. We'll also allow
        // nil segments because they represent audience segments that we haven't fetched from the API. That usually
        // means that we don't care about them.
        // segment can be null if we don't have the segment data in the Redux store. See
        // https://trello.com/c/Xveek031
        const interestingSegments = segmentIds.filter(
            seg => !_isNil(seg) && interestingAudiences.includes(seg.audienceId)
        );
        return interestingSegments.every(seg =>
            selectedSegments.includes(seg.id)
        );
    });
}

function filterByB2bResponse(driverQuotes, selectedB2bFilters) {
    return driverQuotes.filter(
        ({
            DEM_B2B_Age: age,
            DEM_B2B_Revenue: revenue,
            DEM_B2B_Role: role,
            DEM_B2B_Size: size
        }) => {
            const responses = [age, revenue, role, size].filter(
                response => !!response
            ); // only look for defined values
            return responses.every(response =>
                selectedB2bFilters.some(filter =>
                    B2B_VALUE_DICT[filter].options.includes(response)
                )
            );
        }
    );
}

function filterBySentiment(driverQuotes, selectedSentiments) {
    return driverQuotes.filter(({ sentiment }) => {
        return selectedSentiments.includes(sentiment);
    });
}

function DriverQuotes({ driverQuotes, showSentiment, showB2bFilters }) {
    return (
        <main className={styles.content}>
            <section className={styles.leftContent}>
                <DriverQuotesSearch />
                <DriverQuotesTable
                    showSentiment={showSentiment}
                    showB2b={showB2bFilters}
                    driverQuotes={driverQuotes}
                />
            </section>
            <section className={styles.rightContent}>
                <DriverQuotesFilter
                    showSentiment={showSentiment}
                    showB2bFilters={showB2bFilters}
                />
            </section>
        </main>
    );
}

function mapStateToProps(state, props) {
    const showSentiment = props.driverQuotes.some(
        driverQuote => driverQuote.sentiment
    );

    const showB2bFilters = props.wevo.audienceCategory && props.wevo.audienceCategory.id === B2B_CATEGORY_ID;

    let driverQuotes = props.driverQuotes;
    driverQuotes = !showB2bFilters
        ? filterBySegment(
              driverQuotes,
              [
                  GENDER_AUDIENCE_ID,
                  AGE_AUDIENCE_ID,
                  INCOME_AUDIENCE_ID,
                  EDUCATION_AUDIENCE_ID
              ],
              state.drivers.selectedSegments
          )
        : driverQuotes;
    driverQuotes = showSentiment
        ? filterBySentiment(driverQuotes, state.drivers.selectedSentiments)
        : driverQuotes;
    driverQuotes = showB2bFilters
        ? filterByB2bResponse(driverQuotes, state.drivers.selectedB2bFilters)
        : driverQuotes;

    if (!_isEmpty(state.drivers.searchQuery)) {
        driverQuotes = search(
            ["quote"],
            driverQuotes,
            state.drivers.searchQuery
        );
    }

    return {
        showSentiment,
        driverQuotes,
        showB2bFilters
    };
}

DriverQuotesTable.propTypes = {
    driverQuotes: PropTypes.array.isRequired
};

export default connect(
    mapStateToProps,
    null
)(DriverQuotes);



// WEBPACK FOOTER //
// ./src/components/Results/DriverQuotes.js